import React from 'react';
import type { WeddingPropType } from '../types';

function NameSectionMiddle({ wedding }: { wedding: WeddingPropType }): JSX.Element {
  return (
    <div className="name-section-middle">
      <div className="content">
        <h1 className="name-1">
          {wedding.owner_first_name && (
            <span
              className={[
                'first-name',
                wedding.owner_first_name.length > 12 ? 'name-wrap' : null,
              ].join(' ')}
            >
              <span className="first-initial">{wedding.owner_first_name[0]}</span>
              <span className="full-first-name">
                {wedding.owner_first_name.slice(1, wedding.owner_first_name.length)}
              </span>
            </span>
          )}
          {wedding.owner_last_name && (
            <span className="last-name">
              <span className="last-initial"> {wedding.owner_last_name[0]}</span>
              <span className="full-last-name">
                {wedding.owner_last_name.slice(1, wedding.owner_last_name.length)}
              </span>
            </span>
          )}
        </h1>
        <span className="amp">&amp;</span>
        <span className="and">and</span>
        <span className="plus">+</span>
        <h1 className="name-2">
          {wedding.partner_first_name && (
            <span className="first-name">
              <span className="first-initial">{wedding.partner_first_name[0]}</span>
              <span className="full-first-name">
                {wedding.partner_first_name.slice(1, wedding.partner_first_name.length)}
              </span>
            </span>
          )}
          {wedding.partner_last_name && (
            <span className="last-name">
              <span className="last-initial"> {wedding.partner_last_name[0]}</span>
              <span className="full-last-name">
                {wedding.partner_last_name.slice(1, wedding.partner_last_name.length)}
              </span>
            </span>
          )}
        </h1>
      </div>
    </div>
  );
}

export default NameSectionMiddle;
